import { Routes, Route, Navigate } from 'react-router-dom'

import BillingOEMView from 'Presentation/Views/Billing/OEM/View'
import BillingMarketplaceView from 'Presentation/Views/Billing/Marketplace/View'
import BillingInvoiceView from 'Presentation/Views/Billing/Invoice/View'
import MarketplaceBillingInvoiceView from 'Presentation/Views/Billing/MarketplaceInvoice/View'

const BillingRoutes = () => (
	<Routes>
		{/* Route: OEM */}
		<Route path="oem" element={<BillingOEMView />} />
		{/* Route: OEM */}

		{/* Route: Marketplace */}
		<Route path="marketplace" element={<BillingMarketplaceView />} />
		{/* Route: Marketplace */}

		{/* Route: Marketplace */}
		<Route path="invoicem" element={<MarketplaceBillingInvoiceView />} />
		{/* Route: Marketplace */}

		{/* Route: Invoice */}
		<Route path="invoiceoem" element={<BillingInvoiceView />} />
		{/* Route: Invoice */}

		{/* Route: Billing Default */}
		<Route index element={<Navigate to="/billing/oem" />} />
		<Route path="*" element={<Navigate to="/billing/oem" />} />
	</Routes>
)

export default BillingRoutes
